import {Component, Input, OnInit} from '@angular/core';

import {Router} from '@angular/router';
import {debounceTime} from 'rxjs/operators';
import {Subject} from 'rxjs';

import {AuthUser, TokenService} from '../../../../core/auth';
import {PageRequest} from '../../../../core';
import {ProjectService} from '../../../../core/services';
import {Project, ProjectResponse} from '../../../../core/models';
import {BreadcrumbService} from '../../../../breadcrumb.service';
import {ProjectSidebarService} from '../../../../projectsidebar.service';

@Component({
  selector: 'app-project-list',
  templateUrl: './project-list.page.html',
  styleUrls: ['./project-list.page.scss']
})
export class ProjectListPage implements OnInit {
  @Input() query = new PageRequest(1, 20);
  private searchTerms = new Subject<PageRequest>();
  projectResponse = new ProjectResponse();
  projects: Project[];
  loading = false;
  authUser: AuthUser = this.token.whoAmI();


  constructor(
    private router: Router,
    private projectService: ProjectService,
    private token: TokenService,
    private breadcrumbService: BreadcrumbService,
    private projectSidebarService: ProjectSidebarService
  ) {
    this.breadcrumbService.setItems([
      {label: 'projects'},
    ]);
    this.projectSidebarService.setProject(null);
  }

  ngOnInit() {
    this.searchProjects(this.query);
    this.searchTerms.pipe(debounceTime(500)).subscribe(
      (query) => {
        this.searchProjects(query);
      }
    );

  }

  navigateToCreateNew() {
    this.router.navigate(['/project']);
  }

  search(query: PageRequest): void {
    this.searchTerms.next(query);
  }

  change(query: PageRequest): void {
    this.searchProjects(query);
  }

  onSortChange(event) {
    this.query.sortField = event.value.sortField;
    this.query.sortDir = event.value.sortDir;
    this.searchProjects(this.query);
  }

  paginate(event) {

    this.query.page = (event.first / event.rows) + 1;
    this.query.sortField = (event.sortField !== undefined) ? event.sortField : 'name';
    this.query.sortDir = this.query.getSortDir(event.sortOrder);
    this.searchProjects(this.query);
  }

  getAllProjects() {
    this.loading = true;
    this.projectService.getAll()
      .subscribe(
        (data) => {
          this.projects = data;
          this.loading = false;
        }, (error) => {
            this.loading = false;
        }
      );

  }

  searchProjects(query?: PageRequest): void {
    this.loading = true;
    this.projectService.search(this.query)
      .subscribe(
        (data) => {
          this.projectResponse = data;
          this.projects = data.content;
          this.loadImages(this.projects);
          this.loading = false;
        }, (error) => {
            this.loading = false;
        }
      );
  }

  loadImages(projects: Project[]) {
    if (projects) {
      projects.forEach((p) => {
        this.loadImage(p);
      });
    }
  }

  loadImage(project: Project) {
    this.projectService.getOneImage(project.id)
      .subscribe(
        (data) => {
          project.imageContents = data.imageContents;
        }
      );
  }
}
